// Generated login passwords (8 chars, no look-alike characters like l/1/O/0).
export function genPassword(length = 8) {
  const charset =
    "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%&*";

  const random = new Uint32Array(length);
  window.crypto.getRandomValues(random);

  let out = "";

  for (let i = 0; i < length; i++) {
    out += charset[random[i] % charset.length];
  }

  return out;
}
